module.exports = __webpack_public_path__ + "img/lagoa-comprida.b2321814.jpg";